try {
  window.Popper = require("popper.js").default;
  window.$ = window.jQuery = require("jquery");
} catch (e) {}
import "../sass/index.scss";
import "./masonry";
import "./charts";
import "./popover";
import "./scrollbar";
import "./search";
import "./sidebar";
import "./skycons";
import "./vectorMaps";
import "./chat";
// import "./datatable";
import "./datepicker";
import "./email";
import "./fullcalendar";
import "./googleMaps";
import "./utils";
